<!-- Header -->
<h3 mat-dialog-title
    translate>
    <span *ngIf="headerText">{{headerText | translate}}</span>
    <div *ngIf="!headerText">
        <span *ngIf="!forEdit && !forImport">
            Save As New Query
        </span>
        <span *ngIf="forEdit && !forImport">
            Edit Query
        </span>
        <span *ngIf="!forEdit && forImport">
            Import Query
        </span>
    </div>
</h3>

<!-- Body -->
<mat-dialog-content style="width: 540px">

    <!-- Import Query Form -->
    <form>

        <!-- Import Option -->
        <tyl-radio-group *ngIf="forImport"
            arrange="vertical"
            labelPosition="after"
            name="Import Option"
            [(selected)]="importOption"
            [values]="[0, 1]"
            [labels]="['Import from file (must be file created from export of existing query)', 'Import existing template from Classic application']"
            [ids]="['importOption0', 'importOption1']"
            [contentTemplate]="importRadioTemplate"></tyl-radio-group>

        <!-- Query Parameters -->
        <div style="display: flex; flex-direction: column; align-items: stretch;">

            <!-- Name -->
            <tyl-form-field label="Name"
                style="width: 100%">
                <input matInput
                    #nameInput
                    name="Name"
                    title="Name"
                    required
                    [(ngModel)]="query.QueryName"
                    maxlength="40">
            </tyl-form-field>

            <!-- Description -->
            <tyl-form-field label="Description"
                hint="{{query.Description ? 200 - query.Description.length : 200}} characters left"
                style="width: 100%">
                <textarea matInput
                    #descriptionInput
                    rows="3"
                    name="Description"
                    title="Description"
                    maxlength="200"
                    [(ngModel)]="query.Description"></textarea>
            </tyl-form-field>

            <!-- Scope -->
            <label>Scope</label>
            <tyl-radio-group arrange="vertical"
                labelPosition="after"
                name="Scope"
                [(selected)]="scopeObject"
                [values]="scopeOptions"
                [labels]="scopeLabels"
                [ids]="scopeIds"
                (selectedChange)="viewScopeChange()"
                [disabledValues]="scopeDisabledOptions"
                [contentTemplate]="scopeRadioTemplate"></tyl-radio-group>

            <!-- Publish to Integration -->
            <tyl-checkbox *ngIf="permissions && permissions.canPublishToIntegration"
                [(checked)]="query.Published">
                Publish to Integration Services
            </tyl-checkbox>
            <label style="margin-top: 10px;"
                *ngIf="forEdit && !forImport && permissions.canUserTakeOwnershipOfQuery && query.OwnerID != currentUser.Id">Owner</label>
            <div
                *ngIf="forEdit && !forImport && permissions.canUserTakeOwnershipOfQuery && query.OwnerID != currentUser.Id">
                <span>{{query.OwnerName}}</span>
                <span style="float: right;"><a class="link"
                        (click)="takeOwnershipClick()">Take Ownership</a></span>
            </div>
        </div>
    </form>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

    <!-- Right Buttons -->
    <div class="footerRight">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png"
            [label]="forImport ? 'Import' : 'Save'"
            (clickEvent)="forImport ? import() : save()"></tyl-button>
        <tyl-button image="Cancel.png"
            label="Cancel"
            (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>

<!-- Import Radio Template -->
<ng-template #importRadioTemplate
    let-value="value">
    <add-file *ngIf="value == 0"
        #addFileComponent
        accepts=""
        [disabled]="importOption != 0"
        [required]="importOption == 0"
        [readAsText]="true"
        [(fileName)]="fileName"
        [(fileType)]="fileType"
        (fileStringChange)="setFile($event)"></add-file>
    <div *ngIf="value == 1"
        style="display: flex; flex-direction: row;">
        <label class="templateName">
            <span>
                {{templateName ? templateName : ('Template Name' | translate)}}
            </span>
            &nbsp;
            <span style="color: red; font-weight: bold;"
                *ngIf="importOption == 1">
                *
            </span>
        </label>
        <button mat-button
            #templateSelectButton
            [disabled]="importOption != 1"
            (click)="importQuerySelect()">
            Select
        </button>
    </div>
</ng-template>

<!-- Scope Radio Template -->
<ng-template #scopeRadioTemplate
    let-value="value">
    <div *ngIf="value == 'Selected Sites'">
        Available to&nbsp;
        <a (click)="selectedSitesClick()"
            [ngStyle]="{
				'color': query.Scope == 'Selected Sites' ? null : 'grey'
			}"
            #selectedSitesLink>
            Selected Sites
        </a>
    </div>
</ng-template>